import React from 'react';
import { FaLock, FaCheckCircle, FaShieldAlt } from 'react-icons/fa';
import { useTheme } from '../context/ThemeContext';

const SecurityNotice: React.FC = () => {
    const primaryColor = import.meta.env.VITE_PRIMARY_COLOR || '#5B1A8B';
    const { isDark } = useTheme();

    const bg = isDark ? '#111111' : '#F8F8F8';
    const cardBg = isDark ? '#1A1A1A' : '#FFFFFF';
    const borderColor = isDark ? '#2A2A2A' : '#F0EAF8';
    const textMain = isDark ? '#FFFFFF' : '#1A1A1A';
    const textBody = isDark ? '#D1D5DB' : '#374151';

    return (
        <section className="w-full py-10 md:py-16" style={{ background: bg }}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div
                    className="rounded-3xl p-6 sm:p-8 md:p-12"
                    style={{ backgroundColor: primaryColor, border: `1.5px solid ${primaryColor}` }}
                >
                    <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-start">

                        {/* Left Side */}
                        <div className="flex-1 space-y-6 w-full">
                            <div className="flex flex-col sm:flex-row sm:items-center gap-4 md:gap-6">
                                <div className="inline-flex p-4 rounded-2xl w-fit bg-white/20">
                                    <FaShieldAlt className="text-3xl md:text-4xl text-yellow-300" />
                                </div>
                                <div>
                                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold leading-tight text-white">
                                        Security Notice
                                    </h2>
                                    <p className="text-xs md:text-sm font-bold uppercase tracking-wider mt-2 text-white/80">
                                        Fraud Awareness • Stay Protected
                                    </p>
                                </div>
                            </div>

                            <div className="rounded-2xl p-5 bg-white/10 border border-white/20">
                                <p className="text-lg sm:text-xl md:text-2xl font-bold leading-relaxed text-white">
                                    ⚠️ <span style={{ color: '#D97706' }}>Fraudsters Alert!</span> Stay vigilant.
                                </p>
                            </div>

                            <ul className="space-y-3">
                                {[
                                    "Do not click unknown links or reply to suspicious messages",
                                    "Verify email IDs and domains before engaging",
                                    "Be cautious of calls claiming to be from us"
                                ].map((item, index) => (
                                    <li key={index} className="flex items-start gap-3 rounded-xl p-4 bg-white/10 border border-white/20">
                                        <FaCheckCircle className="mt-1 shrink-0 text-lg md:text-xl text-yellow-300" />
                                        <span className="text-base sm:text-lg font-semibold leading-snug text-white">
                                            {item}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Right Side: Safe Payment Box */}
                        <div className="w-full lg:w-[400px] shrink-0">
                            <div className="p-6 sm:p-8 rounded-3xl h-full" style={{ backgroundColor: cardBg, border: `1.5px solid ${borderColor}` }}>
                                <div className="flex items-center gap-3 mb-5">
                                    <div className="p-3 rounded-xl" style={{ backgroundColor: `${primaryColor}12` }}>
                                        <FaLock className="text-xl" style={{ color: primaryColor }} />
                                    </div>
                                    <h3 className="text-base md:text-lg font-extrabold uppercase tracking-wide" style={{ color: primaryColor }}>
                                        Safe Payment
                                    </h3>
                                </div>
                                <p className="text-base sm:text-lg md:text-xl font-bold mb-6 leading-snug" style={{ color: textMain }}>
                                    Pay only through our official website or authorised links.
                                </p>
                                <div className="pt-6 border-t-2" style={{ borderColor }}>
                                    <p className="text-sm md:text-base font-semibold leading-relaxed" style={{ color: textBody }} lang="hi">
                                        भुगतान केवल आधिकारिक वेबसाइट से करें। किसी अज्ञात लिंक पर भरोसा न करें।
                                    </p>
                                </div>
                                <div className="mt-6 p-4 rounded-xl" style={{ backgroundColor: `${primaryColor}10` }}>
                                    <p className="text-sm font-bold text-center" style={{ color: primaryColor }}>
                                        🔒 100% Secure Transactions
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default SecurityNotice;
